<template>
  <div style="margin-top: 1px;">
    <el-container>
      <el-header height="140px">
        <div style="display: flex;justify-content: space-around;">
          <div>
            <div>
              <h3>下载本图需要{{ theImageNeedsPoints }}点</h3>
            </div>
            <div>
              <h3>您所剩余额{{ nowUserHadPoints }}点</h3>
            </div>
          </div>
          <div>
            <div style="margin-top: 30px;">
              <el-button @click="downImage" type="warning" round
                >兑换下载</el-button
              >
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <div>
          <hr />
          <a href="#/imgList/convas" style="color: red; text-decoration:none;"
            >(下载使用版权声明)</a
          >
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  props: {
    imageId: String,
    imageName: String
  },
  mounted () {
    this.imgId = this.imageId
    this.imgName = this.imageName
    this.initImageInfo()
  },
  data () {
    return {
      imgId: '',
      imgName: '',
      theImageNeedsPoints: 0,
      nowUserHadPoints: 0
    }
  },
  methods: {
    initImageInfo () {
      const api = '/md/front/unpaid/getPointsInfoByImg'
      const params = {
        id: this.imgId,
        iname: this.imgName
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.theImageNeedsPoints = res.data.imgPoints
          this.nowUserHadPoints = res.data.userOwnerPoints
        }
      })
    },
    downImage () {
      if (this.nowUserHadPoints <= 0 || this.nowUserHadPoints < this.theImageNeedsPoints) {
        this.$alert('点数不足,请先充值')
        return
      }
      const downurl = '/md/front/paid/down?id='
      let cmdstr = this.imgId + '&iname=' + this.imgName
      cmdstr = encodeURI(cmdstr)
      cmdstr = downurl + cmdstr + '&sun=' + Math.random()
      // eslint-disable-next-line no-debugger
      debugger
      window.open(cmdstr, '_blank')
    }
  },
  watch: {
    imageId (newV) {
      this.initImageInfo()
    }
  }
}
</script>

<style scoped></style>
